/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { SubjectContractOwnershipDto } from './subjectContractOwnershipDto.model';
import { NonCadastralParcel } from './nonCadastralParcel.model';
import { NonCadastralSubject } from './nonCadastralSubject.model';
import { DepartmentNonCadastralContract } from './departmentNonCadastralContract.model';


export interface NonCadastralContractListResponseDto { 
    contractNumber?: number;
    contractNumberOfficial?: string;
    contractSubjectOwnerships?: Array<SubjectContractOwnershipDto>;
    counterpartyNumber?: string;
    departmentNonCadastralContractList?: Array<DepartmentNonCadastralContract>;
    durationMonths?: number;
    expirationDate?: string;
    id?: number;
    indefinite?: boolean;
    moveBlockingInfo?: string;
    owners?: Array<NonCadastralSubject>;
    parcelIds?: Array<number>;
    parcels?: Array<NonCadastralParcel>;
    readyToMove?: boolean;
    signatureDate?: string;
    subjectOrderName?: string;
    tenants?: Array<SubjectContactResponseDto>;
}

